import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { linkProfile } from "@/data/companies-invitations";
import { logout, refresh } from "@/data/session";
import { SessionContext } from "@/infrastructure/Session";
import { useToasts } from "@/views/components/Toast/useToasts";
import { router } from "@/views/router";

type TResult = (invitationId: number, invitationToken: string) => Promise<boolean>;

export const useLinkProfileAfterInvitation = (): TResult => {
  const { update } = useContext(SessionContext);
  const { addToast } = useToasts();
  const { t } = useTranslation("public");
  const history = useHistory();

  return useCallback(
    async (invitationId: number, invitationToken: string) => {
      try {
        await linkProfile({ token: invitationToken });

        const refreshedUser = await refresh();
        update(refreshedUser);

        addToast({
          text: t("SESSION_INVITATION.ADD_TO_EXISTING_SUCCESS"),
          type: "success",
        });

        return true;
      } catch (error) {
        addToast({
          text:
            error?.payload?.code === "ALREADY_EXISTS"
              ? t("SESSION_INVITATION.ADD_TO_EXISTING_EXISTS_ERROR")
              : t("SESSION_INVITATION.ADD_TO_EXISTING_ERROR"),
          type: "danger",
        });

        await logout();

        history.push(router.get("consultant-invitations.accept", { invitationId }, { token: invitationToken }).path);

        return false;
      }
    },
    [update, addToast, t, history],
  );
};
